import * as CategoryType from 'show-page/constants/category-type';
import * as ClipLayout from 'show-page/constants/clip-layout';
import CategoryNav from 'common/components/category-nav';
import CategoryNavItem from 'common/components/category-nav/item';
import ClipLayoutMenu from 'show-page/components/clip-layout-menu';
import ClipList from 'show-page/components/clip-list';
import ClipSearchForm from 'show-page/components/clip-search-form';
import ClipSearchResults from 'show-page/components/clip-search-results';
import ClipSeasonFilter from 'show-page/components/clip-season-filter';
import Environment from 'common/utils/environment';
import LoadMoreButton from 'show-page/components/load-more-button';
import Season from 'show-page/components/season';
import styles from './styles.less';
import WatchASLogo from 'common/components/watch-as-logo';
import { findDOMNode } from 'react-dom';
import { observer } from 'mobx-react';


@observer(['cvpAuthStore', 'showStore', 'uiStore'])
class ShowContent extends React.Component {
    static propTypes = {
        onVideoSelect: React.PropTypes.func.isRequired
    };

    render() {
        const className = cx(styles.root, this.props.className);
        return (
            <div className={ className }>
                { this.renderHeader() }
                { this.renderEpisodes() || this.renderClips() }
            </div>
        );
    }

    renderClips() {
        if (!this.props.showStore.showClipsNav || this.props.uiStore.selectedCategory !== CategoryType.CLIPS) {
            return null;
        }
        const { onVideoSelect, showStore, uiStore } = this.props;
        const clipContext = showStore.searchResults ? showStore.searchResults : showStore.selectedSeason;
        const clips = showStore.searchResults ? showStore.searchResults.videos : (showStore.selectedSeason || showStore).clips;
        return (
            <div className={ styles.clips }>
                <header className={ styles.clipsHeader }>
                    <ClipSearchForm
                        className={ styles.clipSearchForm }
                        onClear={ this.handleClearClipSearch }
                        onSearch={ this.handleClipSearch }
                        query={ showStore.currentSearchQuery }
                    />
                    { !!showStore.searchResults &&
                    <ClipSearchResults
                        className={ styles.clipSearchResults }
                        onClearSearch={ this.handleClearClipSearch }
                        searchResults={ showStore.searchResults }
                    /> }
                    { (!showStore.searchResults && showStore.clipsSeasonNumbers.length > 1) &&
                    <ClipSeasonFilter
                        className={ styles.clipSeasonFilter }
                        highlightColor={ showStore.highlightColor }
                        onSeasonSelect={ this.handleSeasonFilterSelect }
                        rolloverTextColor={ showStore.rolloverTextColor }
                        seasonNumbers={ showStore.clipsSeasonNumbers }
                        selectedSeasonNumber={ showStore.selectedSeason.number }
                    /> }
                    <ClipLayoutMenu
                        className={ styles.clipLayoutMenu }
                        currentLayout={ uiStore.clipLayout }
                        onLayoutSelect={ this.handleClipLayoutSelect }
                    />
                </header>
                <ClipList
                    clips={ clips }
                    highlightColor={ showStore.highlightColor }
                    onVideoSelect={ onVideoSelect }
                    rolloverTextColor={ showStore.rolloverTextColor }
                    selectedVideoId={ showStore.selectedVideoId }
                    textOnly={ uiStore.clipLayout === ClipLayout.LIST }
                />
                { (!!clipContext && !!clipContext.canLoadMore) &&
                <LoadMoreButton
                    className={ styles.loadMoreButton }
                    loading={ clipContext.isLoading }
                    onClick={ this.handleLoadMore }
                /> }
            </div>
        );
    }

    renderEpisodes() {
        if ((this.props.showStore.showClipsNav && this.props.uiStore.selectedCategory !== CategoryType.EPISODES) || this.props.showStore.seasons.length < 1) {
            return null;
        }
        const { cvpAuthStore, onVideoSelect, showStore } = this.props;
        return (
            <div className={ styles.seasons }>
                { showStore.sortedSeasons.map((season, i) => (
                    <Season
                        className={ styles.season }
                        highlightColor={ showStore.highlightColor }
                        key={ i }
                        onMoreClipsSelect={ this.handleMoreClipsSelect }
                        onVideoSelect={ onVideoSelect }
                        rolloverTextColor={ showStore.rolloverTextColor }
                        season={ season }
                        selectedVideoId={ showStore.selectedVideoId }
                        tveAuthenticated={ cvpAuthStore.isAuthenticated }
                    />
                )) }
            </div>
        );
    }

    renderHeader() {
        const { showClipsNav, hasAuthEpisodes, title } = this.props.showStore;
        const { isAuthenticated } = this.props.cvpAuthStore;
        const { selectedCategory } = this.props.uiStore
        return (
            <header className={ styles.header }>
                <h1 className={ styles.headerTitle }>{ title }</h1>
                { !!hasAuthEpisodes &&
                <div className={ styles.watchASBlock }>
                    <WatchASLogo authenticated={ isAuthenticated } />&ensp;=&ensp;Requires a cable provider login
                </div> }
                { !!showClipsNav &&
                <CategoryNav className={ styles.categoryNav }>
                    <CategoryNavItem
                        category={ CategoryType.EPISODES }
                        onClick={ this.handleCategorySelect }
                        selected={ selectedCategory === CategoryType.EPISODES }>
                        Episodes
                    </CategoryNavItem>
                    <CategoryNavItem
                        category={ CategoryType.CLIPS }
                        onClick={ this.handleCategorySelect }
                        selected={ selectedCategory === CategoryType.CLIPS }>
                        Clips
                    </CategoryNavItem>
                </CategoryNav> }
            </header>
        );
    }

    handleCategorySelect = (category) => {
        this.props.uiStore.selectCategory(category);
    };

    handleClearClipSearch = () => {
        this.props.showStore.clearSearchQuery();
    };

    handleClipLayoutSelect = (layout) => {
        this.props.uiStore.setClipLayout(layout);
    };

    handleClipSearch = (query) => {
        this.props.showStore.searchClips(query);
    };

    handleLoadMore = () => {
        if (this.props.showStore.searchResults) {
            this.props.showStore.searchResults.search();
        } else if (this.props.showStore.selectedSeason) {
            this.props.showStore.selectedSeason.loadClips();
        }
    };

    handleMoreClipsSelect = () => {
        this.props.uiStore.selectCategory(CategoryType.CLIPS);
        this.scrollToTop();
    };

    handleSeasonFilterSelect = (seasonNumber) => {
        this.props.showStore.setSeasonFilter(seasonNumber);
    };

    scrollToTop() {
        const el = findDOMNode(this);
        if (Environment.mobile && 'scrollIntoView' in el) {
            el.scrollIntoView();
        } else {
            const { stickyPlayerHeight, stickyPlayerState } = this.props.uiStore;
            const offsetY = stickyPlayerState ? stickyPlayerHeight : 0;
            TweenLite.to(window, 0.5, { scrollTo: { y: el, offsetY } });
        }
    }
}


export default ShowContent;



/** WEBPACK FOOTER **
 ** ./src/show-page/containers/show-content/index.js
 **/